<template>
  <div>
    <section-title
      content="4. Información Adicional"
      icon="fa fa-user"
      reverse
    />
    <div class="additional-information">
      <section class="section-panel">
        <div class="section-panel__body">
          <div class="question-field">
            <label class="question-label">
              <span>
                Fuentes de empleo más comunes en el área residencial del
                estudiante:
              </span>
              <em>
                (ejemplo: agricultura, servicios o tipo de industrias más
                comunes, otras)
              </em>
            </label>
            <custom-text-area
              v-model="model.commonEmploymentSourcesResidentialArea"
              class="question-textarea"
              :disabled="readOnly"
              :maxlength="5000"
              placeholder=""
              show-char-count
              :count-classes="['d-block text-right']"
            />
          </div>

          <custom-text-area
            v-model="model.availableTransportation"
            class="question-textarea question-textarea--spaced"
            :disabled="readOnly"
            label="Medios de transportación disponible:"
            :maxlength="5000"
            placeholder=""
            show-char-count
            :count-classes="['d-block text-right']"
          />

          <div class="question-field question-field--spaced">
            <label class="question-label">
              <span>Otros comentarios:</span>
              <em>
                (aditamentos, habilidades o destrezas, precauciones,
                experiencias de trabajo, otras)
              </em>
            </label>
            <custom-text-area
              v-model="model.otherComments"
              class="question-textarea"
              :disabled="readOnly"
              :maxlength="5000"
              placeholder=""
              show-char-count
              :count-classes="['d-block text-right']"
            />
          </div>

          <validation-provider
            v-slot="{ errors }"
            name="Razón del referido"
            rules="required|min:20"
          >
            <custom-text-area
              v-model="model.referralReason"
              class="question-textarea question-textarea--spaced"
              :disabled="readOnly"
              :error="errors[0]"
              :custom-error-msg="'Este campo es requerido'"
              label="Razón del referido:"
              :maxlength="5000"
              placeholder=""
              show-char-count
              :count-classes="['d-block text-right']"
            />
          </validation-provider>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import SectionTitle from 'SectionTitle';

export default {
  name: 'AdditionalInformationSection',
  components: {
    CustomTextArea,
    SectionTitle,
  },
  props: {
    readOnly: Boolean,
    value: {
      type: Object,
      default: () => null,
    },
    additionalInformation: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    model: {
      get() {
        return this.value || this.additionalInformation || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.additional-information {
  background: #fdfdfb;
  color: #111;
  padding: 8px 18px 24px;
}

.section-panel {
  border: 1px solid #dfe4e1;
  border-radius: 6px;
  margin-bottom: 24px;
  overflow: visible;
  position: relative;
}

.section-panel__body {
  background: #fafbfa;
  padding: 24px 26px 24px;
}

.question-field--spaced,
.question-textarea--spaced {
  margin-top: 22px;
}

.question-label {
  color: #111;
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
  margin-bottom: 8px;
}

.question-label em {
  color: #111;
  display: block;
  font-style: italic;
  font-weight: 700;
}

::v-deep .question-textarea textarea {
  min-height: 70px;
}

::v-deep .question-textarea .custom-input-label,
::v-deep .question-textarea .data-label,
::v-deep .question-textarea label,
::v-deep .question-textarea span,
::v-deep .question-textarea .text-right {
  color: #111 !important;
  font-size: 14px;
}

::v-deep .question-textarea .custom-input-label,
::v-deep .question-textarea .data-label,
::v-deep .question-textarea label {
  display: block;
  font-weight: 500;
  line-height: 1.25;
  margin-bottom: 8px;
}

@media (max-width: 767.98px) {
  .additional-information {
    padding: 8px 0 16px;
  }
}
</style>
